var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNuclearButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(-.253 .967 -.967 -.253 -1259.093 4140.031)",
    gradientUnits: "userSpaceOnUse",
    x1: -4208.582,
    x2: -4215.268,
    xlinkHref: "#lg1",
    y1: -398.322,
    y2: -364.106
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-.034 .999 -.999 -.034 -1004.387 4591.555)",
    gradientUnits: "userSpaceOnUse",
    x1: -4439.863,
    x2: -4466.025,
    xlinkHref: "#lg1",
    y1: -1020.879,
    y2: -994.717
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(-.253 .967 -.967 -.253 -1259.093 4140.031)",
    gradientUnits: "userSpaceOnUse",
    x1: -4169.336,
    x2: -4202.845,
    xlinkHref: "#lg1",
    y1: -356.826,
    y2: -323.317
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(1 -.017 .017 1 2166.425 4437.612)",
    gradientUnits: "userSpaceOnUse",
    x1: -1846.247,
    x2: -1825.808,
    xlinkHref: "#lg1",
    y1: -4372.002,
    y2: -4199.5
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(1 -.017 .017 1 2166.425 4437.612)",
    gradientUnits: "userSpaceOnUse",
    x1: -1837.193,
    x2: -1903.414,
    xlinkHref: "#lg2",
    y1: -4334.51,
    y2: -4509.464
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 -1 510 819.269)",
    gradientUnits: "userSpaceOnUse",
    x1: 233.65,
    x2: 262.043,
    xlinkHref: "#lg2",
    y1: 671.573,
    y2: 746.187
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.469,
    x2: 458.469,
    y1: 78.09,
    y2: 213.292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c1ea76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9563,
    stopColor: "#a1e66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ee66a"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 255.331,
    y2: 384.921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 329.2,
    y2: 416.443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2346,
    stopColor: "#fe653c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6509,
    stopColor: "#fb4628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.859,
    x2: 255.859,
    xlinkHref: "#lg3",
    y1: 397.869,
    y2: 435.605
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f7fc"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.605,
    x2: 144.605,
    xlinkHref: "#lg4",
    y1: 340.713,
    y2: 215.38
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.91,
    x2: 320.91,
    xlinkHref: "#lg4",
    y1: 400.953,
    y2: 228.953
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 427.087,
    y2: 464.824
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m163.701 197.475c4.003-1.638 7.117-4.644 8.379-8.605l10.26-32.17c3.775-11.825 11.131-22.256 21.194-30.401-19.444-5.922-39.722 1.201-46.811 16.538-1.803 3.901-3.383 7.907-4.728 12.007l-9.035 27.557c-1.637 4.99.066 10.317 3.955 14.279 1.013.494 2.073.916 3.194 1.251 4.776 1.449 9.625 1.167 13.592-.456z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.482 197.331 23.49-38.447c3.497-5.72 7.252-11.244 11.249-16.556 15.713-20.886 44.761-26.367 67.097-12.794-16.408 9.528-30.34 23.103-40.29 39.627l-27.054 44.955c-3.329 5.535-8.617 9.201-14.452 10.625-5.781 1.411-12.113.623-17.604-2.703-1.29-.773-2.466-1.659-3.549-2.64-3.266-6.817-3.141-15.105 1.113-22.067z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.575 189.389 40.19-41.406c5.982-6.16 12.231-12.001 18.723-17.511 25.521-21.662 63.356-20.316 87.432 2.941-23.186 7.275-44.42 20.305-61.51 38.142l-46.478 48.532c-5.72 5.976-13.36 9.064-21.051 9.198-7.62.132-15.308-2.638-21.23-8.341-1.394-1.329-2.612-2.768-3.69-4.299-2.158-9.439.335-19.757 7.614-27.256z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.627 217.575c11.279 10.848 29.274 10.479 40.099-.822l44.066-46.003c17.149-17.903 38.673-30.675 62.161-37.329.507 14.248 12.372 25.525 26.75 25.276l17.392-.301c34.463-.596 68.318 9.07 97.224 27.759 33.225 21.483 75.194 24.507 111.186 8.012l89.293-40.923-.526-30.374-1.544-89.211-17.33 4.107c-60.023 14.225-121.415 21.938-183.104 23.005l-71.493 1.237c-66.774 1.155-130.357 28.673-176.76 76.498l-38.102 39.272c-10.849 11.181-10.54 28.998.688 39.797z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.998 49.215 1.8 104.026-89.291 40.928c-14.766 6.761-30.531 10.25-46.288 10.522-22.662.392-45.302-5.859-64.9-18.531-28.906-18.689-62.765-28.363-97.228-27.767l-17.385.301c-4.79.083-9.307-1.108-13.205-3.273-3.247-1.785-6.061-4.243-8.269-7.177-3.15-4.145-5.079-9.263-5.281-14.824-23.485 6.658-45.012 19.428-62.157 37.327l-44.066 46.005c-9.237 9.649-23.7 11.327-34.75 4.854-4.523-10.161-2.716-22.463 5.515-30.941l38.1-39.28c46.404-47.823 109.989-75.337 176.76-76.492l71.498-1.237c61.684-1.067 123.084-8.784 183.101-23.003z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.954 133.421c.507 14.248 12.372 25.525 26.75 25.276l17.392-.301c34.463-.596 68.318 9.07 97.224 27.759 33.225 21.483 75.194 24.507 111.186 8.012l3.397-1.557-69.712-67.34-35.112-8.278c-34.744-8.191-70.374-12.022-106.065-11.404l-18.774.325c-14.52.251-26.549 12.234-26.297 26.755.001.163.011.753.011.753z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m423.544 215.658h69.849c9.172 0 16.607-7.435 16.607-16.607v-153.887c0-9.172-7.435-16.607-16.607-16.607h-69.849c-9.172 0-16.607 7.435-16.607 16.607v153.887c.001 9.172 7.436 16.607 16.607 16.607z",
    fill: "url(#SVGID_7_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m433.23 441.99h-356.46v-160.85c0-21.996 17.831-39.827 39.827-39.827h276.807c21.996 0 39.827 17.831 39.827 39.827v160.85z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m377.119 417.97h-244.238l14.857-80.213c4.349-23.482 24.832-40.52 48.714-40.52h117.096c23.882 0 44.365 17.037 48.714 40.52z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.961 452.224h-298.203v-28.551c0-16.506 13.381-29.887 29.887-29.887h238.429c16.506 0 29.887 13.381 29.887 29.887z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.902 441.99h-311.804v-141.004c0-19.259 15.612-34.871 34.871-34.871h242.062c19.259 0 34.871 15.612 34.871 34.871z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.23 441.99v-160.85c0-9.702-3.473-18.59-9.238-25.499l-186.349 186.349z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.362 481.443h-348.724c-8.244 0-14.927-6.683-14.927-14.927v-13.623c0-16.506 13.381-29.887 29.887-29.887h318.804c16.506 0 29.887 13.381 29.887 29.887v13.623c0 8.244-6.683 14.927-14.927 14.927z",
    fill: "url(#SVGID_13_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNuclearButton);
export default __webpack_public_path__ + "static/media/icon-nuclear-button.18d1499908ffaa5dfd89d9fac0598d91.svg";
export { ForwardRef as ReactComponent };